const domain = 'INSTITUTION_SETTINGS/GROUP_MOVES';

export const CONFIRM_ACTION_TYPE = `${domain}/CONFIRMING`;
export const FILTER_GROUP_ACTION_TYPE = `${domain}/FILTER_GROUP`;

export const CONFIRM_LEAVE_ACTION_TYPE = `${domain}/CONFIRMING_LEAVE`;
export const CONFIRM_LEAVE_ACTION_TYPE_SUCCESS = `${domain}/CONFIRMING_LEAVE_SUCCESS`;

export const CANCELING_LEAVE_ACTION_TYPE = `${domain}/CANCELING_LEAVE`;
export const CANCELING_LEAVE_ACTION_TYPE_SUCCESS = `${domain}/CANCELING_LEAVE_SUCCESS`;

export const SHOW_UPCOMING_CHILDREN = `${domain}/SHOW_UPCOMING_CHILDREN`;
